import script from "./LivePlayer.vue?vue&type=script&setup=true&lang=js"
export * from "./LivePlayer.vue?vue&type=script&setup=true&lang=js"

import "./LivePlayer.vue?vue&type=style&index=0&id=21f8db97&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21f8db97"]])

export default __exports__